import { render, staticRenderFns } from "./RestrictUserForm.vue?vue&type=template&id=ab3e8cf6&scoped=true"
import script from "./RestrictUserForm.vue?vue&type=script&lang=ts"
export * from "./RestrictUserForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3e8cf6",
  null
  
)

export default component.exports